import { useTranslation } from 'react-i18next';
import { Period } from '../types';
import { Select } from '@octano/global-ui';

interface PeriodSelectorSectionProps {
  periods: Period[];
  onPeriodChange: (periodId: number) => void;
  disabled?: boolean;
}

export default function PeriodSelectorSection({
  periods,
  onPeriodChange,
  disabled = false,
}: PeriodSelectorSectionProps) {
  const { t } = useTranslation('configuration/enrollment-and-tuition');

  const periodOptions = periods.map((period) => ({
    label: period.name,
    value: period.id,
  }));

  return (
    <Select
      name="selectedPeriod"
      label={t('periodSelector.label')}
      options={periodOptions}
      onChange={(option) => onPeriodChange(option.value)}
      disabled={disabled}
      isClearable={false}
      isSearchable={false}
      placeholder={t('periodSelector.placeholder')}
    />
  );
}
